const SPARKS = {
  intro: [
    { x: 7, y: 16, s: 7, d: 0.2, dur: 2.8, tone: "gold" },
    { x: 14, y: 38, s: 5, d: 1.1, dur: 3.4, tone: "navy" },
    { x: 22, y: 12, s: 4, d: 0.6, dur: 2.3, tone: "gold" },
    { x: 31, y: 54, s: 6, d: 1.8, dur: 3.1, tone: "coral" },
    { x: 42, y: 20, s: 5, d: 0.4, dur: 2.9, tone: "gold" },
    { x: 58, y: 10, s: 8, d: 1.5, dur: 3.6, tone: "cream" },
    { x: 71, y: 28, s: 5, d: 0.9, dur: 2.6, tone: "gold" },
    { x: 82, y: 14, s: 6, d: 2.1, dur: 3.0, tone: "coral" },
    { x: 90, y: 42, s: 7, d: 1.3, dur: 3.3, tone: "gold" },
    { x: 18, y: 72, s: 4, d: 2.4, dur: 2.5, tone: "gold" },
    { x: 48, y: 78, s: 5, d: 0.7, dur: 3.2, tone: "navy" },
    { x: 76, y: 68, s: 6, d: 1.9, dur: 2.7, tone: "cream" },
    { x: 93, y: 62, s: 4, d: 0.3, dur: 2.4, tone: "gold" },
  ],
  exp: [
    { x: 8, y: 22, s: 5, d: 0.5, dur: 3.1, tone: "navy" },
    { x: 16, y: 48, s: 4, d: 1.6, dur: 2.6, tone: "gold" },
    { x: 28, y: 18, s: 6, d: 0.2, dur: 3.4, tone: "gold" },
    { x: 39, y: 62, s: 5, d: 2.0, dur: 2.9, tone: "coral" },
    { x: 52, y: 12, s: 4, d: 1.1, dur: 2.4, tone: "navy" },
    { x: 64, y: 36, s: 7, d: 0.8, dur: 3.5, tone: "gold" },
    { x: 78, y: 24, s: 5, d: 1.7, dur: 3.0, tone: "gold" },
    { x: 88, y: 58, s: 6, d: 0.4, dur: 2.8, tone: "coral" },
    { x: 12, y: 78, s: 4, d: 2.3, dur: 3.2, tone: "gold" },
    { x: 46, y: 84, s: 5, d: 1.4, dur: 2.7, tone: "navy" },
    { x: 91, y: 80, s: 4, d: 0.9, dur: 3.3, tone: "gold" },
  ],
  fun: [
    { x: 10, y: 18, s: 6, d: 0.3, dur: 2.5, tone: "coral" },
    { x: 19, y: 44, s: 5, d: 1.2, dur: 3.2, tone: "gold" },
    { x: 33, y: 14, s: 8, d: 0.6, dur: 3.6, tone: "gold" },
    { x: 47, y: 32, s: 4, d: 1.9, dur: 2.4, tone: "coral" },
    { x: 61, y: 8, s: 6, d: 0.1, dur: 2.9, tone: "cream" },
    { x: 74, y: 40, s: 7, d: 1.5, dur: 3.4, tone: "gold" },
    { x: 86, y: 22, s: 5, d: 2.2, dur: 2.7, tone: "coral" },
    { x: 12, y: 68, s: 5, d: 0.8, dur: 3.1, tone: "gold" },
    { x: 38, y: 76, s: 9, d: 1.6, dur: 3.8, tone: "coral" },
    { x: 58, y: 82, s: 4, d: 0.4, dur: 2.6, tone: "gold" },
    { x: 79, y: 70, s: 6, d: 2.0, dur: 3.0, tone: "cream" },
    { x: 94, y: 54, s: 5, d: 1.0, dur: 2.8, tone: "gold" },
  ],
};

export const AboutSky = ({ tone = "intro" }) => (
  <div className={`about-sky about-sky--${tone}`} aria-hidden="true">
    <div className="about-constellation" />
    <div className="about-stars" />
    <div className="about-noise" />
    <div className="about-sparkles">
      {(SPARKS[tone] || SPARKS.intro).map((spark) => (
        <span
          className={`spark spark-${spark.tone}`}
          key={`${tone}-${spark.x}-${spark.y}`}
          style={{
            left: `${spark.x}%`,
            top: `${spark.y}%`,
            width: spark.s,
            height: spark.s,
            animationDelay: `${spark.d}s`,
            animationDuration: `${spark.dur}s`,
          }}
        />
      ))}
      <span className="shooting-star ss-a" />
      <span className="shooting-star ss-b" />
      <span className="shooting-star ss-c" />
      <span className="shooting-star ss-d" />
      <span className="shooting-star ss-e" />
    </div>
  </div>
);
